import { type } from 'arktype';
import { baseJunctionQuerySchema, baseJunctionCreateSchema, BaseJunction } from './shared';

/**
 * Query schema for filtering calendar-team associations
 */
export const calendarTeamQuerySchema = baseJunctionQuerySchema
  .and(
    type({
      'teamId?': type('string').configure({
        description: 'Filter associations by the linked team ID.',
        examples: ['team_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Query parameters for listing calendar-to-team associations.' });
export type CalendarTeamQuery = typeof calendarTeamQuerySchema.t;

/**
 * Schema for creating a calendar-team association
 */
export const createCalendarTeamSchema = baseJunctionCreateSchema
  .and(
    type({
      teamId: type('string').configure({
        description: 'ID of the team the calendar is being associated with.',
        examples: ['team_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Payload for linking a calendar to a team.' });
export type CreateCalendarTeam = typeof createCalendarTeamSchema.t;

/**
 * Calendar-Team association response DTO
 */
export interface CalendarTeam extends BaseJunction {
  teamId: string;
}
